import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

const getUserDefaultState = () => {
  return {
    reusername: '',
    repassword: '',
    id: 0,
    user_name: '',
    roles_id: 0,
    email: '',
    accessToken: '',
    projectToken: '',
    section: false,
    defaultProject: 1,
  };
};

const moduleUser = {
  namespaced: true,
  state: getUserDefaultState(),
  actions: {
    login(context, payload) {
      context.commit('LOGIN', payload);
    },
    updateToken(context, payload) {
      context.commit('TOKEN_UPDATE', payload);
    },
    rememberPwd(context, payload) {
      context.commit('PWD_REMEMBER', payload);
    },
    resetState(context) {
      context.commit('STATE_RESET');
    },
    //管理頁面參數
    updateSection(context, payload) {
      context.commit('SECTION_UPDATE', payload);
    },
  },
  mutations: {
    LOGIN(state, payload) {
      state.id = payload.id;
      state.user_name = payload.user_name;
      state.roles_id = payload.roles_id;
      state.email = payload.email;
      state.accessToken = payload.accessToken;
    },
    TOKEN_UPDATE(state, payload) {
      state.projectToken = payload.projectToken;
    },
    PWD_REMEMBER(state, payload) {
      state.reusername = payload.username;
      state.repassword = payload.password;
    },
    STATE_RESET(state) {
      let reusername = state.reusername;
      let repassword = state.repassword;
      Object.assign(state, getUserDefaultState());
      state.reusername = reusername;
      state.repassword = repassword;
    },
    SECTION_UPDATE(state, payload) {
      state.section = payload.section;
    },
  },
};

const getMemberDefaultState = () => {
  return {
    line_toke: '',
    line_user_name: '',
    avatar: 'https://180dc.org/wp-content/uploads/2018/05/empty-300x300.png',

    // V2 新增
    token: '',
    user_type: '', // "admin" 或 "user"
    user_id: 0,
    email: '',
    all_buildings: [], // 僅 admin 有（所有建案）
  };
};

const moduleMember = {
  namespaced: true,
  state: getMemberDefaultState(),
  actions: {
    login(context, payload) {
      context.commit('LOGIN', payload);
    },
    v2Login(context, payload) {
      context.commit('V2_LOGIN', payload);
    },
    resetState(context) {
      context.commit('STATE_RESET');
    },
  },
  mutations: {
    LOGIN(state, payload) {
      state.line_toke = payload.line_toke;
      state.line_user_name = payload.line_user_name;
      state.avatar = payload.avatar;
    },
    V2_LOGIN(state, payload) {
      state.token = payload.token;
      state.user_type = payload.user_type;
      state.user_id = payload.user_info.id;
      state.email = payload.user_info.email;

      if (payload.user_type === 'admin') {
        state.all_buildings = payload.user_info.all_buildings || [];
      } else {
        state.line_user_name = payload.user_info.line_user_name;
        state.avatar = payload.user_info.avatar;
      }
    },
    STATE_RESET(state) {
      Object.assign(state, getMemberDefaultState());
    },
  },
  getters: {
    isAdmin(state) {
      return state.user_type === 'admin';
    },
    authToken(state) {
      return state.token || state.line_toke;
    },
  },
};

export default new Vuex.Store({
  modules: {
    user: moduleUser,
    member: moduleMember,
  },
  plugins: [vuexLocal.plugin],
});
